export const cleanString = textContent => {
  // Strip out any HTML entities
  const textHolder = document.createElement('textarea')
  textHolder.innerHTML = textContent
  return textHolder.value
}